import e from "./highrise1574.mjs";
import t from "./highrise1314.mjs";
function m(r, o) {
  return r && e(r, o, t);
}
export {
  m as default
};
